import moment, { Moment } from 'moment-timezone';
import { START_TIME_OF_THE_DAY, TIMEZONE } from '../constants';

/**
 * Returns the business date for the given moment.
 * At Teco, a working day starts at 11:00 a.m.
 */
const getBusinessDate = (
  currentDate: Moment = moment.tz(TIMEZONE),
  format = 'YYYY-MM-DD',
): string => {
  return currentDate
    .clone()
    .subtract(START_TIME_OF_THE_DAY, 'hours')
    .format(format);
};

export default getBusinessDate;
